module.exports = __webpack_public_path__ + "img/resized-APP-0005-1.070e04d4.png";